
<template>
	<div>
		<compWrapper :title="getTitle" theme="primary">
			<compFormQuery :formdata="getBase" :value="formData"></compFormQuery>
		</compWrapper>
		<vTableSimple
			:columns="columnsQuery"
			:data="formData.shipmentPlanOrderItems"
			size="small"
			border
			stripe
		></vTableSimple>
		<vLoading loading size="large" transfer v-if="loading"></vLoading>
	</div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import { HttpTransferBill } from '@/service/boss/shipment'
export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
	},
	data() {
		return {
			loading: false,
			id: this.$route.query.id,
			formData: {
				shipmentPlanOrderItems: [],
			}
		}
	},
	created() {
		this.getDetail();
	},
	computed: {
		// ...mapState('boss', ['products', 'warehouseList']),
		...mapGetters('diction',['getNewProductList','getNewWarehouseIdList']),
		getTitle(formData) {
			const { transferNo, orderStatus } = this.formData,
				status = {
					establish: '已创建',
					submit: '已提交',
					confirm: '已确认',
					reject: '已驳回',
					shipment: '已发运',
					complete: '已完成',
					close: '已取消',
					delete: '已删除',
					draft: '草稿',
				};
			return `入库单${transferNo}（${status[orderStatus]}）`
		},
		getBase() {
			const { orgWarehouseId, addressCode } = this.formData
			const warehouse = this.getNewWarehouseIdList.find(item => {
				return orgWarehouseId == item.value
			}) || {}

			return [{
				label: "来源采购单号",
				key: "sourceOrderNos",
			}, {
				label: "目的仓",
				key: "orderNo",
				valueText: warehouse.label
			}, {
				label: "目的地址",
				key: "addressCode",
				show: !!addressCode
			},
			{
				label: "国家",
				key: "country",
			}, {
				label: "州",
				key: "state",
			}, {
				label: "城市",
				key: "city",
			}, {
				label: "邮编",
				key: "zipcode",
			}, {
				label: "地址",
				key: "address",
			}, {
				label: "联系人",
				key: "contactName",
			}, {
				label: "联系电话",
				key: "contactPhone",
			}, {
				label: "Shipment ID",
				key: "shipmentId",
			}, {
				label: "Referrence ID",
				key: "referrenceId",
			}, {
				label: "建仓时间",
				key: "buildWarehouseAt",
			}, {
				label: "预计到货日期",
				key: "estimateArrivalAt",
			}, {
				label: "到仓日期",
				key: "actualArrivalAt",
			},
			];
		},
		columnsQuery() {
			return [
				{
					title: '#',
					type: 'index',
				},
				{
					title: 'ERP SKU',
					key: 'erpSku',
				},
				{
					title: '项目',
					key: 'lineId',
					render: (h, { row }) => {
						const id = row.lineId;
						const product = this.getNewProductList.find((item) => {
							return id == item.value
						}) || {};
						return product.label
					},
				},
				{
					title: '采购单价',
					key: 'unitPrice',
				},

				{
					title: '采购币种',
					key: 'currency',
				},
				{
					title: '计划发运数量',
					key: 'transferAmount',
				},
				{
					title: '实际发运数量',
					key: 'actualTransferAmount',
				},
				{
					title: '接收数量（可售）',
					key: 'availableAmount',
				},
				{
					title: '接收数量（不可售）',
					key: 'noAvailableAmount',
				},
			]
		},

	},

	methods: {
		//加载详情
		async getDetail() {
			this.loading = true;
			return HttpTransferBill({
				orderId: this.id
			}).then(res => {
				this.formData = res.data || {};
				this.loading = false;
			}, err => {
				this.loading = false;
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			});
		},
	},

}
</script>

